export const StatusPill = ({ status }) => {
  const map = {
    open: "Open",
    in_progress: "In Progress",
    on_hold: "On Hold",
    completed: "Completed",
    cancelled: "Cancelled",
  };
  return (
    <span className={`status-pill status-${status}`} data-testid={`status-${status}`}>
      {map[status] || status}
    </span>
  );
};

export const PriorityPill = ({ priority }) => (
  <span className={`status-pill prio-${priority}`}>{priority}</span>
);

export const TypePill = ({ type }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] border rounded-sm font-mono ${
      type === "PM"
        ? "bg-emerald-50 text-emerald-800 border-emerald-300"
        : "bg-rose-50 text-rose-800 border-rose-300"
    }`}
  >
    {type === "PM" ? "Preventive" : "Corrective"}
  </span>
);
